import React, { useState } from "react";
import { useGetTransactionQuery } from "../../features/api/transactionApi";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";

const DealerSummary = () => {
  const { data: transtion } = useGetTransactionQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const transactions = transtion?.transactions;

  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  const dealerTransactions = {};

  transactions?.forEach((transaction) => {
    const { tag_ac_id, dabit_amount, credit_amount } = transaction;

    if (!dealerTransactions[tag_ac_id]) {
      dealerTransactions[tag_ac_id] = {
        totalDebit: 0,
        totalCredit: 0,
      };
    }

    dealerTransactions[tag_ac_id].totalDebit += dabit_amount;
    dealerTransactions[tag_ac_id].totalCredit += credit_amount;
  });

  Object.keys(dealerTransactions)?.forEach((tag_ac_id) => {
    const dealer = dealerTransactions[tag_ac_id];
    dealer.balance = dealer.totalCredit - dealer.totalDebit;
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-6">
        <h1 className="text-xl font-bold">Client Summary</h1>
      </div>
      <div className="pb-6">
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  <span className="font-bold">Sl No.</span>
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  <span className="font-bold">Client</span>
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  <span className="font-bold">Total Purchase</span>
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  <span className="font-bold">Total Deposit</span>
                </TableCell>
                <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                  <span className="font-bold">Total Due</span>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dealers
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row, i) => (
                  <TableRow key={row.id}>
                    <TableCell>{i + 1}</TableCell>
                    <TableCell>{row?.d_name}</TableCell>
                    <TableCell>
                      {dealerTransactions[row?.id]?.totalDebit}
                    </TableCell>
                    <TableCell>
                      {dealerTransactions[row?.id]?.totalCredit}
                    </TableCell>
                    <TableCell>
                      {dealerTransactions[row?.id]?.balance}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            style={{ backgroundColor: "#f0f0f5" }}
            rowsPerPageOptions={[50, 100, 200]}
            component="div"
            count={dealers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </div>
    </div>
  );
};

export default DealerSummary;
